import { RootState } from '../../types';

export const loading = (state: RootState) => state.partner.streams.loading;
export const url = (state: RootState) => state.partner.streams.url;
